module.exports = {
  '@primary-color': '#81BD41',
  '@sider-color': '#ADAEBA',
}
